import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Field, User } from '../../../models';
import { ApiService, AuthService, ConditionService, DialogService, FieldService, MetadataService, ModalService, TranslatorService } from '../../../services';
import { CalendarService } from '../../../services/calendar.service';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
	selector: 'sn-usc-action-plan',
	templateUrl: './usc-action-plan.component.html',
	styleUrls: ['./usc-action-plan.component.css']
})
export class UscActionPlanComponent implements OnInit {
	@Input() item_ID: number;

	public current_view: string = "";
	public isThisMonthActionPlan: boolean = false;
	public isNextMonthActionPlan: boolean = false;
	public isPrevMonthActionPlan: boolean = false;
	public is_action_plan_loaded: boolean = false;
	public is_store_action_plan: boolean = false;
	public is_assistant_action_plan: boolean = false;
	public isOwner: boolean = true;
	public action_plan: any = { };
	public action_plan_fields: any[];
	public viewConditions: any;
	public viewFormulas: any;
	public active_user: User;
	this_month_action_plan: any;
    portalReadySub:Subscription;
	conditionResults:any;
	calculatedResults:any;
  

	public isDraft:boolean = true;
	public isRequested: boolean = false;
	public isApproved: boolean = false;
	public isApprover: boolean = false;
	public isLeader: boolean = false;
	public isExec:boolean = false;
	public is_saving_lefn: boolean = false;
	// input fields

	public plan_month: string = "Jan";
	public plan_year: string = "2022";

	public total_estimated_payout: number = 0;
	public total_pacing_payout: number = 0;
	public payout_estimate: any;

	public action_plan_values: any = {
		postpaid_basic: { driver: "postpaid_basic", is_goal_editable: true },
		postpaid_everyday: { driver: "postpaid_everyday", is_goal_editable: true },
		postpaid_even_better: { driver: "postpaid_even_better", is_goal_editable: true },
		postpaid: { driver: "postpaid_handset_volume", is_goal_editable: false },
		hsi: { driver: "hsi", is_goal_editable: true },
		prepaid: { driver: "prepaid", is_goal_editable: true },
		connected_devices: { driver: "connected_devices", is_goal_editable: true },
		other_volume: { driver: "other_volume", is_goal_editable: false },
		bir: { driver: "bir", is_goal_editable: true },
		accessories_revenue: { driver: "accessories_revenue", is_goal_editable: true },
		other_revenue: { driver: "other_revenue", is_goal_editable: true },
		upgrades_basic: { driver: "upgrades_basic", is_goal_editable: true },
		upgrades_everyday: { driver: "upgrades_everyday", is_goal_editable: true },
		upgrades_even_better: { driver: "upgrades_even_better", is_goal_editable: true },
		upgrades: { driver: "upgrades", is_goal_editable: false },
		high_msrp_accessories: { driver: "high_msrp_accessories", is_goal_editable: true },
		device_trade_ins: { driver: "device_trade_ins", is_goal_editable: true }
	}
	public business_drivers: any[] = [];

	public pp_p2w_daily_goal: number = 0;
	public pp_mtd_pacing_to_quota: number = 0;
	public pp_mtd_pacing_to_p2w_goal: number = 0;

	public other_p2w_daily_goal: number = 0;
	public other_mtd_pacing_to_quota: number = 0;
	public other_mtd_pacing_to_p2w_goal: number = 0;

	public bir_p2w_daily_goal: number = 0;
	public bir_mtd_pacing_to_quota: number = 0;
	public bir_mtd_pacing_to_p2w_goal: number = 0;

	public ar_p2w_daily_goal: number = 0;
	public ar_mtd_pacing_to_quota: number = 0;
	public ar_mtd_pacing_to_p2w_goal: number = 0;

	public or_p2w_daily_goal: number = 0;
	public or_mtd_pacing_to_quota: number = 0;
	public or_mtd_pacing_to_p2w_goal: number = 0;

	public upgrades_p2w_daily_goal: number = 0;
	public upgrades_mtd_pacing_to_quota: number = 0;
	public upgrades_mtd_pacing_to_p2w_goal: number = 0;

	public hma_p2w_daily_goal: number = 0;
	public hma_mtd_pacing_to_quota: number = 0;
	public hma_mtd_pacing_to_p2w_goal: number = 0;

	public dti_p2w_daily_goal: number = 0;
	public dti_mtd_pacing_to_quota: number = 0;
	public dti_mtd_pacing_to_p2w_goal: number = 0;

	public focus_actions: any[] = [];
	public observation_notes: any[] = [];
	public leader_feedback: any[] = [];
	public leader_feedback_multinotes: any = { previous_notes: "", new_notes: "" };
	public exec_feedback: any[] = [];
	public exec_feedback_multinotes: any = { previous_notes: "", new_notes: "" };

	// status enum
	public status_draft = 1;
	public status_requested = 2;
	public status_approved = -1;
	public status_rejected = -2;
	public status_mapping = {
		"1": "Draft",
		"2": "Submitted for Approval",
		"-1": "Approved",
		"-2": "Rejected",
	}

	// search parameters
	public curPage: number = 1;
	public pageSize: number = 15;
	public orderBy: string = "cs_subject";
	public asc: boolean = false;

	public current_filter: any = {
		owner: { label: "All", value: "" },
	}

	constructor(
		public uscStoreService: UscStoreService,
		public apiService: ApiService,
		public metaDataService: MetadataService,
		public conditionService: ConditionService,
		public fieldService: FieldService,
		public calendarService: CalendarService,
		public translatorService: TranslatorService,
		public dialogService: DialogService,
		public modalService: ModalService,
		public authService: AuthService,
		public ngbModal: NgbModal,
	) {
		this.isLeader = this.uscStoreService.isLeader();
		this.isExec = this.uscStoreService.isExec();		
	}

	ngOnInit() {
		this.isNextMonthActionPlan = this.current_view == this.uscStoreService.view_p2w_next_action_plan;
		this.isThisMonthActionPlan = this.current_view == this.uscStoreService.view_p2w_this_action_plan;
		this.isPrevMonthActionPlan = this.current_view == this.uscStoreService.view_p2w_prev_action_plan;

		// get action plan field config
		this.metaDataService.getFormViewMetaData(this.uscStoreService.view_p2w_action_plan, {}).subscribe(
			result => {
				this.action_plan_fields = result.meta_data.view_fields;
				this.viewConditions = result.meta_data.view_conditions;
				this.viewFormulas = result.meta_data.view_formulas;
			},
			err => { console.log(err) }
		)

        this.portalReadySub = this.uscStoreService.portalReady.subscribe(ready => {
            if (ready && this.is_action_plan_loaded) this.uscStoreService.setCurrentView(this.current_view);
        });

		this.loadActionPlan();
	}

	public isColumnVisible(column) {
		switch (column) {
			case "best":
			case "avg":
				return (this.isDraft || this.isNextMonthActionPlan) && !this.isPrevMonthActionPlan;
			case "daily_goal":
				return !this.isDraft && this.isThisMonthActionPlan;
			case "mtd_actual":
			case "pacing_to_quota":
			case "pacing_to_goal":
				return this.isPrevMonthActionPlan || (!this.isDraft && this.isThisMonthActionPlan);
			default: 
				return true;
		}
	}

	public getColumnHeader(column) {
		var column_headers = {
			best: "Highest Achieving Month's Results",
			avg: "Average Month's Results (90 Days)",
			quota: "Quota",
			monthly_goal: "P2W Monthly Goal",
			daily_goal: "P2W Daily Goal",
			mtd_actual: this.isPrevMonthActionPlan ? "Actual Sales" : "MTD Actual",
			pacing_to_quota: this.isPrevMonthActionPlan ? '% Sales vs Quota' : 'MTD Pacing to Quota',
			pacing_to_goal: this.isPrevMonthActionPlan ? '% Sales vs P2W Goal' : 'MTD Pacing to P2W Goal',
		}
		return column_headers[column];
	}

	public getCellValue(column, bd) {
		switch (column) {
			case "best":
			case "avg":
			case "quota":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.action_plan_values[bd][column];
			case "daily_goal":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.action_plan_values[bd][column].toFixed(0);
			case "pacing_to_quota":
			case "pacing_to_goal":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.translatorService.toPercentage(this.action_plan_values[bd][column]);
			case "mtd_actual":
				break;
		}
	}

	public getCellValueStyle(bd, column) {
		var driver_components = [
			'postpaid_basic',
			'postpaid_everyday',
			'postpaid_even_better',
			'upgrades_basic',
			'upgrades_everyday',
			'upgrades_even_better',
			'hsi',
			'prepaid',
			'conntected_devices',
		];
		var style = {};
		if (bd[column] == null) style = { "background-color": "#2f75b5" };
		return style;
	}

	public showBusinessDriverToolTip(bd) {
		return this.uscStoreService.getBusinessDriverDesc(bd.driver) != null;
	}

	public getBusinessDriverToolTip(bd) {
		return this.uscStoreService.getBusinessDriverDesc(bd.driver);
	}

	processActionPlan(action_plan, subject) {
		if (action_plan) {
			this.action_plan = action_plan;
			this.is_store_action_plan = this.action_plan.ur_title == 'Store';
			this.is_assistant_action_plan = this.action_plan.ur_title == 'Assistant Manager';
			this.isOwner = this.action_plan.ur_user_ID.toString() == this.authService.getActive().ID;
			this.isDraft = this.action_plan.cs_status == this.status_draft;
			this.isRequested = this.action_plan.cs_status == this.status_requested;
			this.isApproved = this.action_plan.cs_status == this.status_approved;
			this.isApprover = this.isRequested && this.isLeader;
			if (this.is_store_action_plan) this.isApprover = this.isRequested && this.isExec;
			this.observation_notes = JSON.parse(this.action_plan.cs_observation_notes);
			this.leader_feedback_multinotes = (this.action_plan.cs_leader_feedback_multinotes) ? JSON.parse(this.action_plan.cs_leader_feedback_multinotes) : { previous_notes: "", new_notes: "" };
			this.exec_feedback_multinotes = (this.action_plan.cs_exec_feedback_multinotes) ? JSON.parse(this.action_plan.cs_exec_feedback_multinotes) : { previous_notes: "", new_notes: "" };
			try { this.focus_actions = JSON.parse(this.action_plan.cs_focus_actions); } catch(e) { this.focus_actions = []; }
			if (this.focus_actions == null) this.focus_actions = [];
			var empty = this.focus_actions.find(a => a.area_of_focus == '' && a.sales_plan_actions == '');
			var empty_index = this.focus_actions.findIndex(a => a.area_of_focus == '' && a.sales_plan_actions == '');
			if (empty_index >= 0 && !this.isDraft) this.focus_actions.splice(empty_index, 1);
			if (empty == undefined && this.isDraft) this.focus_actions.push({ area_of_focus: "", sales_plan_actions: "" });
			this.calculateActionPlanSalesFigures();
			this.preprocessP2WFieldsToCurrency();
			this.processPayout();
			if (this.isThisMonthActionPlan && this.isDraft && this.uscStoreService.isActionPlanRequired()) {
				var msgList = [];				 
				msgList.push("Please note, you must submit your 'This Month's Action Plan' before you can proceed into SalesNOW.");
				var ngbModalRef = this.modalService.openContent(
					DialogComponent,
					{ dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
					{ backdrop: 'static', keyboard: false }
				);
				ngbModalRef.result.then(
					(result) => { ngbModalRef.dismiss(); },
					(reason) => { ngbModalRef.dismiss(); }
				);        
			}
			this.is_action_plan_loaded = true;
		} else {
			this.apiService.getViewItem(this.uscStoreService.view_p2w_action_plan, 0).subscribe(
				result => {
					this.isDraft = true;
					this.action_plan = result.item;
					this.action_plan.cs_subject = subject;
					// initialize monthly_goal
					this.action_plan.cs_p2w_postpaid_basic = this.getQuota('ur_quota_postpaid_basic') + 1;
					this.action_plan.cs_p2w_postpaid_everyday = this.getQuota('ur_quota_postpaid_everyday') + 1;
					this.action_plan.cs_p2w_postpaid_even_better = this.getQuota('ur_quota_postpaid_even_better') + 1;
					this.action_plan.cs_p2w_postpaid = this.getQuota('ur_quota_postpaid_handset') + 1;
					this.action_plan.cs_p2w_hsi = this.getQuota('ur_quota_hsi') + 1;
					this.action_plan.cs_p2w_prepaid = this.getQuota('ur_quota_prepaid') + 1;
					this.action_plan.cs_p2w_connected_devices = this.getQuota('ur_quota_cd') + 1;
					this.action_plan.cs_p2w_other = this.getQuota('ur_quota_other_volume') + 1;
					this.action_plan.cs_p2w_other_revenue = this.getQuota('ur_quota_other_revenue') + 1;
					this.action_plan.cs_p2w_accessories_revenue = this.getQuota('ur_quota_accessories_revenue') + 1;
					this.action_plan.cs_p2w_bir = this.getQuota('ur_quota_bir') + 1;
					this.action_plan.cs_p2w_upgrades_everyday = this.getQuota('ur_quota_upgrades_everyday') + 1;
					this.action_plan.cs_p2w_upgrades_even_better = this.getQuota('ur_quota_upgrades_even_better') + 1;
					this.action_plan.cs_p2w_upgrades = this.getQuota('ur_quota_upgrades') + 1;
					this.action_plan.cs_p2w_high_acc = this.getQuota('ur_quota_high_msrp_accessories') + 1;

					if (this.uscStoreService.isUSCellCorp()) {
						this.action_plan.cs_p2w_postpaid_basic = this.action_plan.cs_p2w_postpaid - 2;
						this.action_plan.cs_p2w_upgrades_basic = this.action_plan.cs_p2w_upgrades - 2;
						this.action_plan.cs_p2w_other = this.action_plan.cs_p2w_hsi + this.action_plan.cs_p2w_prepaid + this.action_plan.cs_p2w_connected_devices;
					}

					this.focus_actions.push({ area_of_focus: "", sales_plan_actions: "" });
					this.observation_notes = JSON.parse(this.action_plan.cs_observation_notes);
					this.leader_feedback_multinotes = { previous_notes: "", new_notes: "" };
					this.exec_feedback_multinotes = { previous_notes: "", new_notes: "" };
					this.calculateActionPlanSalesFigures();
					this.preprocessP2WFieldsToCurrency();
					this.saveActionPlan();
				},
				err => {
					console.log("error");
				}
			)			
		}
	}

	drivers: any[] = [
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "postpaid", label: "Postpaid Handset Volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "other_volume", label: "Other Volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "revenue", label: "Revenue" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "upgrades", label: "Upgrades" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "high_msrp_accessories", label: "High MSRP Accessories",},
    ];

	processPayout() {
		if (!this.isPrevMonthActionPlan) {
			var days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked + 1;
			if (this.isPrevMonthActionPlan) days_remaining = 0;
			if (!this.uscStoreService.isUSCellCorp()) {
				this.uscStoreService.getThisMonthPayoutEstimate(this.drivers, this.action_plan, days_remaining).subscribe(
					result => {
						this.total_estimated_payout = result.total_estimated_payout;
						this.total_pacing_payout = result.total_pacing_payout;
						this.payout_estimate = result.payout_estimate;
					}
				)
			}
			else {
				var month_subject = this.isThisMonthActionPlan ? this.uscStoreService.getThisMonthActionPlanSubject() : this.uscStoreService.getNextMonthActionPlanSubject();
				var params = { est: 'ST_Search', "SP_MONTH_SUBJECT": month_subject, 'SP_ACTION_PLAN_ID': this.action_plan.cs_ID.toString() };
				this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_goal_table, params).subscribe(
					result => {
						this.total_estimated_payout = 0;
						result.items.forEach(bd => {
							this.total_estimated_payout += bd.estimated_payout;
						})        
					},
					err => {
						console.log(err);
					}
				); 

				if (this.isThisMonthActionPlan) {
					this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_forecast_table, params).subscribe(
						result => {
							this.total_pacing_payout = 0;
							result.items.forEach(bd => {
								this.total_pacing_payout += bd.estimated_payout;
							}) 
						},
						err => {
							console.log(err);
						}
					); 
				}
			}
		}
	}

	getNextMonthPayout() {
		if (this.uscStoreService.isUSCellCorp()) return this.total_estimated_payout;
		if (this.isActionPlanGoalsRequired() && this.payout_estimate != null) {
			var action_plan = JSON.parse(JSON.stringify(this.action_plan));
			this.preprocessP2WFields(action_plan, false);
			var result = this.uscStoreService.calculateEstimatedPayout(this.drivers, action_plan, this.payout_estimate, 0, true);
			return result.total_estimated_payout;
		} 
		return 0;
	}

	loadActionPlan() {
		let date = new Date();
		var year = date.getFullYear();
		var month = date.getMonth() + (this.isThisMonthActionPlan ? 1 : 2);
		if (month == 13) {
			year = year + 1;
			month = 1;
		}
		var subject = year.toString() + (month < 10 ? '0' + month.toString() : month.toString());
		this.plan_month = this.calendarService.getAbbrMonthName(month - 1);
		this.plan_year = year.toString();
		// get action plan
		let dlg = this.showCustomPromptDlg({}, { msg: "Retrieving Action Plan..." });
		if (this.item_ID > 0) {
			if (this.current_view == this.uscStoreService.view_p2w_prev_action_plan) {
				var action_plan = this.uscStoreService.getPreviousUserActionPlanByID(this.item_ID);
				this.processActionPlan(action_plan, action_plan.cs_subject);
				this.plan_month = this.calendarService.getAbbrMonthName(parseInt(action_plan.cs_subject.substr(5)) - 1);
				this.plan_year = action_plan.cs_subject.substring(0, 4);
				dlg.dismiss();
				// this.uscStoreService.getPreviousActionPlans().subscribe(items => {
				// 	var action_plan = items.find(i => i.cs_ID == this.item_ID);
				// 	this.processActionPlan(action_plan, action_plan.cs_subject);
				// 	this.plan_month = this.calendarService.getAbbrMonthName(parseInt(action_plan.cs_subject.substr(5)) - 1);
				// 	this.plan_year = action_plan.cs_subject.substring(0, 4);
				// 	dlg.dismiss();
				// });		
			} else {
				this.apiService.getViewItem(this.uscStoreService.view_p2w_action_plan, this.item_ID).subscribe(action_plan => {
					this.processActionPlan(action_plan.item, subject);
					dlg.dismiss();
				});
			}
		} else {
			this.uscStoreService.getThisMonthActionPlans().subscribe(action_plan => {
				// always check current month action plan first 
				if (this.isNextMonthActionPlan) {
					// must create current month's action plan before creating next month's action plan
					if (action_plan == null || action_plan.cs_status == this.status_draft) {
						this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
						dlg.dismiss();
						return;
					}
					else {
						this.this_month_action_plan = action_plan;
						this.uscStoreService.getNextMonthActionPlans().subscribe(action_plan => {
							this.processActionPlan(action_plan, subject);
							dlg.dismiss();
						})
					}
				} else {
					this.processActionPlan(action_plan, subject)
					dlg.dismiss();
				}
			});
		}
	}

	preprocessP2WFieldsToCurrency() {
		this.preprocessP2WFields(this.action_plan, true);
	}

	preprocessP2WFieldsToNumber() {
		this.preprocessP2WFields(this.action_plan, false);
	}

	preprocessP2WFields(action_plan:any, bToCurrency:boolean) {
		// prefix $ to all p2w goals
		for (const p in action_plan) {
			if (p.indexOf('_revenue') >= 0 && p.indexOf('quota') < 0) {
				var value = action_plan[p];
				value = value ? value.toString() : "$0";
				if (value && value.indexOf('$') >= 0) {
					action_plan[p] = parseInt(value.replace('$', ''));
				}
				if (bToCurrency) {
					action_plan[p] = '$' + parseInt(action_plan[p]).toString();
				} 
			}
		}
	}

	calculateActionPlanSalesFigures() {
		// aof (label)
		this.action_plan_values.postpaid_basic.aof = "Postpaid - Basic";
		this.action_plan_values.postpaid_everyday.aof = "Postpaid - Everyday";
		this.action_plan_values.postpaid_even_better.aof = "Postpaid - Even Better";
		this.action_plan_values.postpaid.aof = "Total Postpaid";
		this.action_plan_values.other_volume.aof = "Other Volume";
		this.action_plan_values.bir.aof = "BiR";
		this.action_plan_values.accessories_revenue.aof = "Accessories Revenue ($)";
		this.action_plan_values.other_revenue.aof = "Other Revenue ($)";
		this.action_plan_values.upgrades_basic.aof = "Upgrades - Basic";
		this.action_plan_values.upgrades_everyday.aof = "Upgrades - Everyday";
		this.action_plan_values.upgrades_even_better.aof = "Upgrades - Even Better";
		this.action_plan_values.upgrades.aof = "Total Upgrades";
		this.action_plan_values.high_msrp_accessories.aof = "High MSRP Accessories";
		this.action_plan_values.device_trade_ins.aof = "Device Trade Ins";
		this.action_plan_values.hsi.aof = "HSI";
		this.action_plan_values.prepaid.aof = "Prepaid";
		this.action_plan_values.connected_devices.aof = "Connected Devices";

		if (this.isPrevMonthActionPlan) {
			if (this.is_store_action_plan || this.is_assistant_action_plan) return;
			var sales_vs_quotas = JSON.parse(this.action_plan.cs_sales_vs_quotas);
			var sales_vs_goals = JSON.parse(this.action_plan.cs_sales_vs_goals);
			var days_worked = this.action_plan.days_worked;
			// actual sales - telesales
			this.action_plan.mtd_postpaid_handset_volume = sales_vs_quotas.postpaid_handset_volume;
			this.action_plan.mtd_other_volume = sales_vs_quotas.other_volume;
			this.action_plan.mtd_bir = sales_vs_quotas.bir;
			this.action_plan.mtd_accessories_revenue = sales_vs_quotas.accessory_revenue;
			this.action_plan.mtd_other_revenue = sales_vs_quotas.other_revenue;
			this.action_plan.mtd_upgrades = sales_vs_quotas.upgrades;
			this.action_plan.mtd_high_msrp_accessories = sales_vs_quotas.high_msrp_accessories;
			this.action_plan.mtd_device_trade_ins = sales_vs_quotas.device_trade_ins;
			// % Sales vs Quota
			if (sales_vs_quotas) {
				// legacy - telesales
				this.pp_mtd_pacing_to_quota = sales_vs_quotas.quota_pct_postpaid_handset_volume;
				this.other_mtd_pacing_to_quota = sales_vs_quotas.quota_pct_other_volume;
				this.bir_mtd_pacing_to_quota = sales_vs_quotas.quota_pct_bir;
				this.ar_mtd_pacing_to_quota = sales_vs_quotas.quota_pct_accessories_revenue;
				this.or_mtd_pacing_to_quota = sales_vs_quotas.quota_pct_other_revenue;

				// mtd pacing to quota
				this.action_plan_values.postpaid_basic.pacing_to_quota 		 = sales_vs_quotas.quota_pct_postpaid_basic ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_postpaid_basic) : "N/A";
				this.action_plan_values.postpaid_everyday.pacing_to_quota 	 = sales_vs_quotas.quota_pct_postpaid_everyday ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_postpaid_everyday) : "N/A";
				this.action_plan_values.postpaid_even_better.pacing_to_quota = sales_vs_quotas.quota_pct_postpaid_even_better ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_postpaid_even_better) : "N/A";
				this.action_plan_values.postpaid.pacing_to_quota 			 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_postpaid_handset_volume);
				this.action_plan_values.hsi.pacing_to_quota 				 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_hsi);
				this.action_plan_values.prepaid.pacing_to_quota 			 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_prepaid);
				this.action_plan_values.connected_devices.pacing_to_quota 	 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_connected_devices);
				this.action_plan_values.other_volume.pacing_to_quota 		 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_other_volume);
				this.action_plan_values.bir.pacing_to_quota 				 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_bir);
				this.action_plan_values.accessories_revenue.pacing_to_quota  = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_accessories_revenue);
				this.action_plan_values.other_revenue.pacing_to_quota 		 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_other_revenue);
				this.action_plan_values.upgrades_basic.pacing_to_quota 		 = sales_vs_quotas.quota_pct_upgrades_basic ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_upgrades_basic) : "N/A";
				this.action_plan_values.upgrades_everyday.pacing_to_quota 	 = sales_vs_quotas.quota_pct_upgrades_everyday ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_upgrades_everyday) : "N/A";
				this.action_plan_values.upgrades_even_better.pacing_to_quota = sales_vs_quotas.quota_pct_upgrades_even_better ? this.translatorService.toPercentage(sales_vs_quotas.quota_pct_upgrades_even_better) : "N/A";
				this.action_plan_values.upgrades.pacing_to_quota 			 = this.translatorService.toPercentage(sales_vs_quotas.quota_pct_upgrades);
			}
			// % Sales vs P2W Goal
			if (sales_vs_goals) {
				// legacy - telesales
				this.pp_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_postpaid_handset_volume;
				this.other_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_other_volume;
				this.bir_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_bir;
				this.ar_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_accessory_revenue;
				this.or_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_other_revenue;
				this.upgrades_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_upgrades;
				this.hma_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_high_msrp_accessories;
				this.dti_mtd_pacing_to_p2w_goal = sales_vs_goals.goal_pct_device_trade_ins;

				// mtd pacing to p2w goal
				this.action_plan_values.postpaid_basic.pacing_to_goal 		= sales_vs_goals.goal_pct_postpaid_basic ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_postpaid_basic) : "N/A";
				this.action_plan_values.postpaid_everyday.pacing_to_goal 	= sales_vs_goals.goal_pct_postpaid_everyday ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_postpaid_everyday) : "N/A";
				this.action_plan_values.postpaid_even_better.pacing_to_goal = sales_vs_goals.goal_pct_postpaid_even_better ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_postpaid_even_better) : "N/A";
				this.action_plan_values.postpaid.pacing_to_goal 			= this.translatorService.toPercentage(sales_vs_goals.goal_pct_postpaid_handset_volume);
				this.action_plan_values.hsi.pacing_to_goal 					= this.translatorService.toPercentage(sales_vs_goals.goal_pct_hsi);
				this.action_plan_values.prepaid.pacing_to_goal 				= this.translatorService.toPercentage(sales_vs_goals.goal_pct_prepaid);
				this.action_plan_values.connected_devices.pacing_to_goal 	= this.translatorService.toPercentage(sales_vs_goals.goal_pct_connected_devices);
				this.action_plan_values.other_volume.pacing_to_goal 		= this.translatorService.toPercentage(sales_vs_goals.goal_pct_other_volume);
				this.action_plan_values.bir.pacing_to_goal 					= this.translatorService.toPercentage(sales_vs_goals.goal_pct_bir);
				this.action_plan_values.accessories_revenue.pacing_to_goal 	= this.translatorService.toPercentage(sales_vs_goals.goal_pct_accessory_revenue);
				this.action_plan_values.other_revenue.pacing_to_goal 		= this.translatorService.toPercentage(sales_vs_goals.goal_pct_other_revenue);
				this.action_plan_values.upgrades_basic.pacing_to_goal 		= sales_vs_goals.goal_pct_upgrades_basic ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_upgrades_basic) : "N/A";
				this.action_plan_values.upgrades_everyday.pacing_to_goal 	= sales_vs_goals.goal_pct_upgrades_everyday ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_upgrades_everyday) : "N/A";
				this.action_plan_values.upgrades_even_better.pacing_to_goal = sales_vs_goals.goal_pct_upgrades_even_better ? this.translatorService.toPercentage(sales_vs_goals.goal_pct_upgrades_even_better) : "N/A";
				this.action_plan_values.upgrades.pacing_to_goal 			= this.translatorService.toPercentage(sales_vs_goals.goal_pct_upgrades);
				this.action_plan_values.high_msrp_accessories.pacing_to_goal= this.translatorService.toPercentage(sales_vs_goals.goal_pct_high_msrp_accessories);
				this.action_plan_values.device_trade_ins.pacing_to_goal 	= this.translatorService.toPercentage(sales_vs_goals.goal_pct_device_trade_ins);
				// monthly_goal
				this.action_plan_values.postpaid_basic.monthly_goal 		= sales_vs_goals.goal_postpaid_basic;
				this.action_plan_values.postpaid_everyday.monthly_goal 		= sales_vs_goals.goal_postpaid_everyday;
				this.action_plan_values.postpaid_even_better.monthly_goal 	= sales_vs_goals.goal_postpaid_even_better;
				this.action_plan_values.postpaid.monthly_goal 				= sales_vs_goals.goal_postpaid_handset_volume;
				this.action_plan_values.hsi.monthly_goal 					= sales_vs_goals.goal_hsi;
				this.action_plan_values.prepaid.monthly_goal 				= sales_vs_goals.goal_prepaid;
				this.action_plan_values.connected_devices.monthly_goal 		= sales_vs_goals.goal_connected_devices;
				this.action_plan_values.other_volume.monthly_goal 			= sales_vs_goals.goal_other_volume;
				this.action_plan_values.bir.monthly_goal 					= sales_vs_goals.goal_bir;
				this.action_plan_values.accessories_revenue.monthly_goal 	= sales_vs_goals.goal_accessory_revenue;
				this.action_plan_values.other_revenue.monthly_goal 			= sales_vs_goals.goal_other_revenue;
				this.action_plan_values.upgrades_basic.monthly_goal 		= sales_vs_goals.goal_upgrades_basic;
				this.action_plan_values.upgrades_everyday.monthly_goal 		= sales_vs_goals.goal_upgrades_everyday;
				this.action_plan_values.upgrades_even_better.monthly_goal 	= sales_vs_goals.goal_upgrades_even_better;
				this.action_plan_values.upgrades.monthly_goal 				= sales_vs_goals.goal_upgrades;
				this.action_plan_values.high_msrp_accessories.monthly_goal 	= sales_vs_goals.goal_high_msrp_accessories;
				this.action_plan_values.device_trade_ins.monthly_goal 		= sales_vs_goals.goal_device_trade_ins;			
			}

			// quota
			this.action_plan_values.postpaid_basic.quota 		= sales_vs_quotas.quota_postpaid_basic;
			this.action_plan_values.postpaid_everyday.quota 	= sales_vs_quotas.quota_postpaid_everyday;
			this.action_plan_values.postpaid_even_better.quota 	= sales_vs_quotas.quota_postpaid_even_better;
			this.action_plan_values.postpaid.quota 				= sales_vs_quotas.quota_postpaid_handset_volume;
			this.action_plan_values.hsi.quota 					= sales_vs_quotas.quota_hsi;
			this.action_plan_values.prepaid.quota 				= sales_vs_quotas.quota_prepaid;
			this.action_plan_values.connected_devices.quota 	= sales_vs_quotas.quota_connected_devices;
			this.action_plan_values.other_volume.quota 			= sales_vs_quotas.quota_other_volume;
			this.action_plan_values.bir.quota 					= sales_vs_quotas.quota_bir;
			this.action_plan_values.accessories_revenue.quota 	= sales_vs_quotas.quota_accessory_revenue;
			this.action_plan_values.other_revenue.quota 		= sales_vs_quotas.quota_other_revenue;
			this.action_plan_values.upgrades_basic.quota 		= sales_vs_quotas.quota_upgrades_basic;
			this.action_plan_values.upgrades_everyday.quota 	= sales_vs_quotas.quota_upgrades_everyday;
			this.action_plan_values.upgrades_even_better.quota 	= sales_vs_quotas.quota_upgrades_even_better;
			this.action_plan_values.upgrades.quota 				= sales_vs_quotas.quota_upgrades;
			this.action_plan_values.high_msrp_accessories.quota = sales_vs_quotas.quota_high_msrp_accessories;
			this.action_plan_values.device_trade_ins.quota 		= sales_vs_quotas.quota_device_trade_ins;
			// mtd
			this.action_plan_values.postpaid_basic.mtd_actual 		= sales_vs_quotas.postpaid_basic ? sales_vs_quotas.postpaid_basic.toFixed(0) : "N/A";
			this.action_plan_values.postpaid_everyday.mtd_actual 	= sales_vs_quotas.postpaid_everyday ? sales_vs_quotas.postpaid_everyday.toFixed(0) : "N/A";
			this.action_plan_values.postpaid_even_better.mtd_actual = sales_vs_quotas.postpaid_even_better ? sales_vs_quotas.postpaid_even_better.toFixed(0) : "N/A";
			this.action_plan_values.postpaid.mtd_actual 			= sales_vs_quotas.postpaid_handset_volume.toFixed(0);
			this.action_plan_values.hsi.mtd_actual 					= sales_vs_quotas.hsi.toFixed(0);
			this.action_plan_values.prepaid.mtd_actual 				= sales_vs_quotas.prepaid.toFixed(0);
			this.action_plan_values.connected_devices.mtd_actual 	= sales_vs_quotas.connected_devices.toFixed(0);
			this.action_plan_values.other_volume.mtd_actual 		= sales_vs_quotas.other_volume.toFixed(0);
			this.action_plan_values.bir.mtd_actual 					= sales_vs_quotas.bir.toFixed(0);
			this.action_plan_values.accessories_revenue.mtd_actual 	= sales_vs_quotas.accessory_revenue.toFixed(0);
			this.action_plan_values.other_revenue.mtd_actual 		= sales_vs_quotas.other_revenue.toFixed(0);
			this.action_plan_values.upgrades_basic.mtd_actual 		= sales_vs_quotas.upgrades_basic ? sales_vs_quotas.upgrades_basic.toFixed(0) : "N/A";
			this.action_plan_values.upgrades_everyday.mtd_actual 	= sales_vs_quotas.upgrades_everyday ? sales_vs_quotas.upgrades_everyday.toFixed(0) : "N/A";
			this.action_plan_values.upgrades_even_better.mtd_actual = sales_vs_quotas.upgrades_even_better ? sales_vs_quotas.upgrades_even_better.toFixed(0) : "N/A";
			this.action_plan_values.upgrades.mtd_actual 			= sales_vs_quotas.upgrades.toFixed(0);
			this.action_plan_values.high_msrp_accessories.mtd_actual= sales_vs_quotas.high_msrp_accessories.toFixed(0);
			this.action_plan_values.device_trade_ins.mtd_actual 	= sales_vs_quotas.device_trade_ins.toFixed(0);
		} else {
			// daily goals
			var days_scheduled = this.action_plan.cs_days_scheduled; 
			this.pp_p2w_daily_goal = this.action_plan.cs_p2w_postpaid / days_scheduled;
			this.other_p2w_daily_goal = this.action_plan.cs_p2w_other / days_scheduled;
			this.bir_p2w_daily_goal = this.action_plan.cs_p2w_bir / days_scheduled;
			this.ar_p2w_daily_goal = this.action_plan.cs_p2w_accessories_revenue / days_scheduled;
			this.or_p2w_daily_goal = this.action_plan.cs_p2w_other_revenue / days_scheduled;
			this.upgrades_p2w_daily_goal = this.action_plan.cs_p2w_upgrades / days_scheduled;
			this.hma_p2w_daily_goal = this.action_plan.cs_p2w_high_acc / days_scheduled;
			this.dti_p2w_daily_goal = this.action_plan.cs_p2w_device_trade_ins / days_scheduled;
			// mtd pacing to quota
			var days_worked = this.action_plan.days_worked;
			this.pp_mtd_pacing_to_quota = this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_handset_volume, days_worked, days_scheduled, this.getQuota('ur_quota_postpaid_handset'));
			this.other_mtd_pacing_to_quota = this.getMtdPacingPercentage(this.action_plan.mtd_other_volume, days_worked, days_scheduled, this.getQuota('ur_quota_other_volume'));
			this.bir_mtd_pacing_to_quota = this.getMtdPacingPercentage(this.action_plan.mtd_bir, days_worked, days_scheduled, this.getQuota('ur_quota_bir'));
			this.ar_mtd_pacing_to_quota = this.getMtdPacingPercentage(this.action_plan.mtd_accessories_revenue, days_worked, days_scheduled, this.getQuota('ur_quota_accessories_revenue'));
			this.or_mtd_pacing_to_quota = this.getMtdPacingPercentage(this.action_plan.mtd_other_revenue, days_worked, days_scheduled, this.getQuota('ur_quota_other_revenue'));
			// mtd pacing to p2w goal
			this.pp_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_handset_volume, days_worked, days_scheduled, this.action_plan.cs_p2w_postpaid);
			this.other_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_other_volume, days_worked, days_scheduled, this.action_plan.cs_p2w_other);
			this.bir_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_bir, days_worked, days_scheduled, this.action_plan.cs_p2w_bir);
			this.ar_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_accessories_revenue, days_worked, days_scheduled, this.action_plan.cs_p2w_accessories_revenue);
			this.or_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_other_revenue, days_worked, days_scheduled, this.action_plan.cs_p2w_other_revenue);
			this.upgrades_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_upgrades, days_worked, days_scheduled, this.action_plan.cs_p2w_upgrades);
			this.hma_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_high_msrp_accessories, days_worked, days_scheduled, this.action_plan.cs_p2w_high_acc);
			this.dti_mtd_pacing_to_p2w_goal = this.getMtdPacingPercentage(this.action_plan.mtd_device_trade_ins, days_worked, days_scheduled, this.action_plan.cs_p2w_device_trade_ins);
			// best
			this.action_plan_values.postpaid_basic.best = this.action_plan.best_postpaid_basic;
			this.action_plan_values.postpaid_everyday.best = this.action_plan.best_postpaid_everyday;
			this.action_plan_values.postpaid_even_better.best = this.action_plan.best_postpaid_even_better;
			this.action_plan_values.postpaid.best = this.action_plan.best_postpaid_handset_volume;
			this.action_plan_values.hsi.best = this.action_plan.best_hsi;
			this.action_plan_values.prepaid.best = this.action_plan.best_prepaid;
			this.action_plan_values.connected_devices.best = this.action_plan.best_connected_devices;
			this.action_plan_values.other_volume.best = this.action_plan.best_other_volume;
			this.action_plan_values.bir.best = this.action_plan.best_bir;
			this.action_plan_values.accessories_revenue.best = this.action_plan.best_accessories_revenue;
			this.action_plan_values.other_revenue.best = this.action_plan.best_other_revenue;
			this.action_plan_values.upgrades_basic.best = this.action_plan.best_upgrades_basic;
			this.action_plan_values.upgrades_everyday.best = this.action_plan.best_upgrades_everyday;
			this.action_plan_values.upgrades_even_better.best = this.action_plan.best_upgrades_even_better;
			this.action_plan_values.upgrades.best = this.action_plan.best_upgrades;
			this.action_plan_values.high_msrp_accessories.best = this.action_plan.best_high_msrp_accessories;
			this.action_plan_values.device_trade_ins.best = this.action_plan.best_device_trade_ins;
			// average
			this.action_plan_values.postpaid_basic.avg = this.action_plan.avg_postpaid_basic;
			this.action_plan_values.postpaid_everyday.avg = this.action_plan.avg_postpaid_everyday;
			this.action_plan_values.postpaid_even_better.avg = this.action_plan.avg_postpaid_even_better;
			this.action_plan_values.postpaid.avg = this.action_plan.avg_postpaid_handset_volume;
			this.action_plan_values.hsi.avg = this.action_plan.avg_hsi;
			this.action_plan_values.prepaid.avg = this.action_plan.avg_prepaid;
			this.action_plan_values.connected_devices.avg = this.action_plan.avg_connected_devices;
			this.action_plan_values.other_volume.avg = this.action_plan.avg_other_volume;
			this.action_plan_values.bir.avg = this.action_plan.avg_bir;
			this.action_plan_values.accessories_revenue.avg = this.action_plan.avg_accessories_revenue;
			this.action_plan_values.other_revenue.avg = this.action_plan.avg_other_revenue;
			this.action_plan_values.upgrades_basic.avg = this.action_plan.avg_upgrades_basic;
			this.action_plan_values.upgrades_everyday.avg = this.action_plan.avg_upgrades_everyday;
			this.action_plan_values.upgrades_even_better.avg = this.action_plan.avg_upgrades_even_better;
			this.action_plan_values.upgrades.avg = this.action_plan.avg_upgrades;
			this.action_plan_values.high_msrp_accessories.avg = this.action_plan.avg_high_msrp_accessories;
			this.action_plan_values.device_trade_ins.avg = this.action_plan.avg_device_trade_ins;
			// quota
			this.action_plan_values.postpaid_basic.quota = this.getQuota('ur_quota_postpaid_basic', null);
			this.action_plan_values.postpaid_everyday.quota = this.getQuota('ur_quota_postpaid_everyday', null);
			this.action_plan_values.postpaid_even_better.quota = this.getQuota('ur_quota_postpaid_even_better', null);
			this.action_plan_values.postpaid.quota = this.getQuota('ur_quota_postpaid_handset', null);
			this.action_plan_values.hsi.quota = this.getQuota('ur_quota_hsi', null);
			this.action_plan_values.prepaid.quota = this.getQuota('ur_quota_prepaid', null);
			this.action_plan_values.connected_devices.quota = this.getQuota('ur_quota_connected_devices', null);
			this.action_plan_values.other_volume.quota = this.getQuota('ur_quota_other_volume', null);
			this.action_plan_values.bir.quota = this.getQuota('ur_quota_bir', null);
			this.action_plan_values.accessories_revenue.quota = this.getQuota('ur_quota_accessories_revenue', null);
			this.action_plan_values.other_revenue.quota = this.getQuota('ur_quota_other_revenue', null);
			this.action_plan_values.upgrades_basic.quota = this.getQuota('ur_quota_upgrades_basic', null);
			this.action_plan_values.upgrades_everyday.quota = this.getQuota('ur_quota_upgrades_everyday', null);
			this.action_plan_values.upgrades_even_better.quota = this.getQuota('ur_quota_upgrades_even_better', null);
			this.action_plan_values.upgrades.quota = this.getQuota('ur_quota_upgrades', null);
			this.action_plan_values.high_msrp_accessories.quota = this.getQuota('ur_quota_high_msrp_accessories', null);
			this.action_plan_values.device_trade_ins.quota = this.getQuota('ur_quota_device_trade_ins', null);
			// mtd
			this.action_plan_values.postpaid_basic.mtd_actual = this.action_plan.mtd_postpaid_basic;
			this.action_plan_values.postpaid_everyday.mtd_actual = this.action_plan.mtd_postpaid_everyday;
			this.action_plan_values.postpaid_even_better.mtd_actual = this.action_plan.mtd_postpaid_even_better;
			this.action_plan_values.postpaid.mtd_actual = this.action_plan.mtd_postpaid_handset_volume;
			this.action_plan_values.hsi.mtd_actual = this.action_plan.mtd_hsi;
			this.action_plan_values.prepaid.mtd_actual = this.action_plan.mtd_prepaid;
			this.action_plan_values.connected_devices.mtd_actual = this.action_plan.mtd_connected_devices;
			this.action_plan_values.other_volume.mtd_actual = this.action_plan.mtd_other_volume;
			this.action_plan_values.bir.mtd_actual = this.action_plan.mtd_bir;
			this.action_plan_values.accessories_revenue.mtd_actual = this.action_plan.mtd_accessories_revenue;
			this.action_plan_values.other_revenue.mtd_actual = this.action_plan.mtd_other_revenue;
			this.action_plan_values.upgrades_basic.mtd_actual = this.action_plan.mtd_upgrades_basic;
			this.action_plan_values.upgrades_everyday.mtd_actual = this.action_plan.mtd_upgrades_everyday;
			this.action_plan_values.upgrades_even_better.mtd_actual = this.action_plan.mtd_upgrades_even_better;
			this.action_plan_values.upgrades.mtd_actual = this.action_plan.mtd_upgrades;
			this.action_plan_values.high_msrp_accessories.mtd_actual = this.action_plan.mtd_high_msrp_accessories;
			this.action_plan_values.device_trade_ins.mtd_actual = this.action_plan.mtd_device_trade_ins;
			// // monthly_goal
			this.action_plan_values.postpaid_basic.monthly_goal = parseInt(this.action_plan.cs_p2w_postpaid_basic);
			this.action_plan_values.postpaid_everyday.monthly_goal = parseInt(this.action_plan.cs_p2w_postpaid_everyday);
			this.action_plan_values.postpaid_even_better.monthly_goal = parseInt(this.action_plan.cs_p2w_postpaid_even_better);
			this.action_plan_values.postpaid.monthly_goal = parseInt(this.action_plan.cs_p2w_postpaid);
			this.action_plan_values.hsi.monthly_goal = parseInt(this.action_plan.cs_p2w_hsi);
			this.action_plan_values.prepaid.monthly_goal = parseInt(this.action_plan.cs_p2w_prepaid);
			this.action_plan_values.connected_devices.monthly_goal = parseInt(this.action_plan.cs_p2w_connected_devices);
			this.action_plan_values.other_volume.monthly_goal = parseInt(this.action_plan.cs_p2w_other);
			this.action_plan_values.bir.monthly_goal = parseInt(this.action_plan.cs_p2w_bir);
			this.action_plan_values.accessories_revenue.monthly_goal = parseInt(this.action_plan.cs_p2w_accessories_revenue);
			this.action_plan_values.other_revenue.monthly_goal = parseInt(this.action_plan.cs_p2w_other_revenue);
			this.action_plan_values.upgrades_basic.monthly_goal = parseInt(this.action_plan.cs_p2w_upgrades_basic);
			this.action_plan_values.upgrades_everyday.monthly_goal = parseInt(this.action_plan.cs_p2w_upgrades_everyday);
			this.action_plan_values.upgrades_even_better.monthly_goal = parseInt(this.action_plan.cs_p2w_upgrades_even_better);
			this.action_plan_values.upgrades.monthly_goal = parseInt(this.action_plan.cs_p2w_upgrades);
			this.action_plan_values.high_msrp_accessories.monthly_goal = parseInt(this.action_plan.cs_p2w_high_acc);
			this.action_plan_values.device_trade_ins.monthly_goal = parseInt(this.action_plan.cs_p2w_device_trade_ins);
			// daily goals
			this.action_plan_values.postpaid_basic.daily_goal = (this.action_plan_values.postpaid_basic.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.postpaid_everyday.daily_goal = (this.action_plan_values.postpaid_everyday.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.postpaid_even_better.daily_goal = (this.action_plan_values.postpaid_even_better.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.postpaid.daily_goal = (this.action_plan_values.postpaid.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.hsi.daily_goal = (this.action_plan_values.hsi.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.prepaid.daily_goal = (this.action_plan_values.prepaid.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.connected_devices.daily_goal = (this.action_plan_values.connected_devices.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.other_volume.daily_goal = (this.action_plan_values.other_volume.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.accessories_revenue.daily_goal = (this.action_plan_values.accessories_revenue.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.other_revenue.daily_goal = (this.action_plan_values.other_revenue.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.bir.daily_goal = (this.action_plan_values.bir.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.upgrades_basic.daily_goal = (this.action_plan_values.upgrades_basic.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.upgrades_everyday.daily_goal = (this.action_plan_values.upgrades_everyday.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.upgrades_even_better.daily_goal = (this.action_plan_values.upgrades_even_better.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.upgrades.daily_goal = (this.action_plan_values.upgrades.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.high_msrp_accessories.daily_goal = (this.action_plan_values.high_msrp_accessories.monthly_goal / days_scheduled).toFixed(0);
			this.action_plan_values.device_trade_ins.daily_goal = (this.action_plan_values.device_trade_ins.monthly_goal / days_scheduled).toFixed(0);
			// mtd pacing to quota
			this.action_plan_values.postpaid.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_handset_volume, days_worked, days_scheduled, this.getQuota('ur_quota_postpaid_handset')));
			this.action_plan_values.hsi.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_hsi, days_worked, days_scheduled, this.getQuota('ur_quota_hsi')));
			this.action_plan_values.prepaid.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_prepaid, days_worked, days_scheduled, this.getQuota('ur_quota_prepaid')));
			this.action_plan_values.connected_devices.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_connected_devices, days_worked, days_scheduled, this.getQuota('ur_quota_connected_devices')));
			this.action_plan_values.other_volume.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_other_volume, days_worked, days_scheduled, this.getQuota('ur_quota_other_volume')));
			this.action_plan_values.bir.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_bir, days_worked, days_scheduled, this.getQuota('ur_quota_bir')));
			this.action_plan_values.accessories_revenue.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_accessories_revenue, days_worked, days_scheduled, this.getQuota('ur_quota_accessories_revenue')));
			this.action_plan_values.other_revenue.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_other_revenue, days_worked, days_scheduled, this.getQuota('ur_quota_other_revenue')));
			this.action_plan_values.upgrades.pacing_to_quota = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_upgrades, days_worked, days_scheduled, this.getQuota('ur_quota_upgrades')));
			// mtd pacing to p2w goal
			this.action_plan_values.postpaid_basic.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_basic, days_worked, days_scheduled, this.action_plan.cs_p2w_postpaid_basic));
			this.action_plan_values.postpaid_everyday.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_everyday, days_worked, days_scheduled, this.action_plan.cs_p2w_postpaid_everyday));
			this.action_plan_values.postpaid_even_better.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_even_better, days_worked, days_scheduled, this.action_plan.cs_p2w_postpaid_even_better));
			this.action_plan_values.postpaid.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_postpaid_handset_volume, days_worked, days_scheduled, this.action_plan.cs_p2w_postpaid));
			this.action_plan_values.hsi.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_hsi, days_worked, days_scheduled, this.action_plan.cs_p2w_hsi));
			this.action_plan_values.prepaid.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_prepaid, days_worked, days_scheduled, this.action_plan.cs_p2w_prepaid));
			this.action_plan_values.connected_devices.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_connected_devices, days_worked, days_scheduled, this.action_plan.cs_p2w_connected_devices));
			this.action_plan_values.other_volume.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_other_volume, days_worked, days_scheduled, this.action_plan.cs_p2w_other));
			this.action_plan_values.bir.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_bir, days_worked, days_scheduled, this.action_plan.cs_p2w_bir));
			this.action_plan_values.accessories_revenue.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_accessories_revenue, days_worked, days_scheduled, this.action_plan.cs_p2w_accessories_revenue));
			this.action_plan_values.other_revenue.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_other_revenue, days_worked, days_scheduled, this.action_plan.cs_p2w_other_revenue));
			this.action_plan_values.upgrades_basic.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_upgrades_basic, days_worked, days_scheduled, this.action_plan.cs_p2w_upgrades_basic));
			this.action_plan_values.upgrades_everyday.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_upgrades_everyday, days_worked, days_scheduled, this.action_plan.cs_p2w_upgrades_everyday));
			this.action_plan_values.upgrades_even_better.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_upgrades_even_better, days_worked, days_scheduled, this.action_plan.cs_p2w_upgrades_even_better));
			this.action_plan_values.upgrades.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_upgrades, days_worked, days_scheduled, this.action_plan.cs_p2w_upgrades));
			this.action_plan_values.high_msrp_accessories.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_high_msrp_accessories, days_worked, days_scheduled, this.action_plan.cs_p2w_high_acc));
			this.action_plan_values.device_trade_ins.pacing_to_goal = this.translatorService.toPercentage(this.getMtdPacingPercentage(this.action_plan.mtd_device_trade_ins, days_worked, days_scheduled, this.action_plan.cs_p2w_device_trade_ins));
		}
		// generate business_drivers array for table
		this.business_drivers = [
			this.action_plan_values.postpaid_basic,
			this.action_plan_values.postpaid_everyday,
			this.action_plan_values.postpaid_even_better,
			this.action_plan_values.postpaid,
			this.action_plan_values.hsi,
			this.action_plan_values.prepaid,
			this.action_plan_values.connected_devices,
			this.action_plan_values.other_volume,
			this.action_plan_values.accessories_revenue,
			this.action_plan_values.other_revenue,
			this.action_plan_values.bir,
			this.action_plan_values.upgrades_basic,
			this.action_plan_values.upgrades_everyday,
			this.action_plan_values.upgrades_even_better,
			this.action_plan_values.upgrades,
			this.action_plan_values.high_msrp_accessories,
			this.action_plan_values.device_trade_ins
		]
	}

	getMtdPacingPercentage(mtd, days_worked, days_scheduled, quota_or_goal) {
		// if days_worked = 0, treat it as days_worked = 1 for calculation prettiness 
		return days_worked > 0 ? mtd / days_worked * days_scheduled / quota_or_goal : mtd / 1 * days_scheduled / quota_or_goal;
	}

	getQuota(field, default_value:any = 0) {
		if (this.action_plan && this.action_plan[field]) {
			var quota = JSON.parse(this.action_plan[field]);
			return quota && quota[this.action_plan.cs_subject] ? quota[this.action_plan.cs_subject] : 0;
		}
		return default_value;
	}

	saveActionPlan() {
		this.preprocessP2WFieldsToNumber();
		var form_fields = this.fieldService.getFormFields(this.action_plan_fields, this.action_plan);
		var reloadActionPlan = (this.action_plan.view_ID == 0);
		this.apiService.saveViewItem(this.uscStoreService.view_p2w_action_plan, this.action_plan.view_ID, form_fields).subscribe(
			result => {
				if (reloadActionPlan) this.loadActionPlan();
				if (this.uscStoreService.isUSCellCorp()) {
					var month_subject = this.isThisMonthActionPlan ? this.uscStoreService.getThisMonthActionPlanSubject() : this.uscStoreService.getNextMonthActionPlanSubject();
					var params = { est: 'ST_Search', "SP_MONTH_SUBJECT": month_subject, 'SP_ACTION_PLAN_ID': this.action_plan.cs_ID.toString() }
					this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_goal_table, params).subscribe(
						result => {
							this.total_estimated_payout = 0;
							result.items.forEach(bd => {
								this.total_estimated_payout += bd.estimated_payout;
							})        
						},
						err => {
							console.log(err);
						}
					); 			
				}
			}
		)
		this.preprocessP2WFieldsToCurrency();
	}

	getCurrency(value) {
		if (value && value.toString().indexOf('$') >= 0) value = value.replace('$', '');
		return this.translatorService.toCurrency(value);
	}

	validateActionPlan() : any[] {
		var errors = [];
		var bValid = true;
		var cs_days_scheduled = parseInt(this.action_plan.cs_days_scheduled);
		var date = new Date();
		var year = date.getFullYear();
		var month = date.getMonth() + (this.isThisMonthActionPlan ? 0 : 1);
		var days_in_month = this.calendarService.getDaysInMonth(year, month);
		if (this.isActionPlanGoalsRequired()) {
			// cs_days_scheduled must be with in days_in_month
			if (isNaN(cs_days_scheduled) || cs_days_scheduled <= 0 || cs_days_scheduled > days_in_month) {
				errors.push("- Days scheduled must be greater than 0 and less than the number of days within the month");
				bValid = false;
			}		
			// all p2w goals cannot be empty and must be more than the base quota
			if (!(this.getQuota('ur_quota_postpaid_handset') < parseInt(this.action_plan.cs_p2w_postpaid) &&
			this.getQuota('ur_quota_other_volume') < parseInt(this.action_plan.cs_p2w_other) &&
			this.getQuota('ur_quota_bir') < parseInt(this.action_plan.cs_p2w_bir) &&
			this.getQuota('ur_quota_accessories_revenue') < parseInt(this.action_plan.cs_p2w_accessories_revenue) &&
			this.getQuota('ur_quota_other_revenue') < parseInt(this.action_plan.cs_p2w_other_revenue) &&
			0 < parseInt(this.action_plan.cs_p2w_upgrades) &&
			0 < parseInt(this.action_plan.cs_p2w_high_acc) &&
			0 < parseInt(this.action_plan.cs_p2w_device_trade_ins))) {
				errors.push("- P2W Goals cannot be empty and must be more than the base quota");
				bValid = false;
			}
		}
		// at least one area of focus
		var focus_actions = JSON.parse(JSON.stringify(this.focus_actions));
		var empty_index = focus_actions.findIndex(a => a.area_of_focus.trim() == '' && a.sales_plan_actions.trim() == '');
		if (empty_index >= 0) focus_actions.splice(empty_index, 1);
		if (focus_actions.length == 0) {
			errors.push("- Must enter at least one Area of Focus");
			bValid = false;
		} 
		// sales_plan_actions cannot be empty
		var empty_spa_index = focus_actions.findIndex(a => a.area_of_focus.trim() == '' || a.sales_plan_actions.trim() == '');
		if (empty_spa_index >= 0) {
			errors.push("- Area of Focus and Sales Plan Action cannot be empty");
			bValid = false;
		}
		// observation notes cannot be empty
		var obseveration_notes = JSON.parse(JSON.stringify(this.observation_notes));
		var empty_notes_index = obseveration_notes.findIndex(a => a.notes.trim() == '');
		if (empty_notes_index >= 0) {
			errors.push("- Observation Notes cannot be empty");
			bValid = false;
		}

		return errors;
	}

	requestForApproval() {
		this.preprocessP2WFieldsToNumber();
		var errors = this.validateActionPlan();
		if (errors.length > 0) {
			var msgList = [];
			msgList.push("");
			msgList = msgList.concat(errors);
			this.modalService.openContent(
				UscDialogComponent,
				{ dlgType: this.uscStoreService.dialog_type_action_plan_approval_warning, msg_config: { errors: msgList }},
				{ size: "lg", backdrop: 'static', keyboard: false }
			).result.then(
				(result) => { this.preprocessP2WFieldsToCurrency() },
				(reason) => { }
			);        
		} else {			
			var msgList = [];
			msgList.push("Please select the approver for your action plan?");
			
			var list = [];
			var leader_approvers = JSON.parse(this.action_plan.leader_approvers).approvers;
			leader_approvers.forEach(a => {
				if (this.is_store_action_plan) {
					if (a.approver_title == "Mgr Retail Area Sales") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Dir Retail Sales and Operations") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
					if (a.approver_title == "Mgr Telesales") list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
				} else {
					list.push({ name: `${a.approver} (${a.approver_title})`, value: a.approver_ID })
				}
			})
			var default_value = list[0].value;
			if (this.authService.getActive().ID == default_value.toString() && list.length > 1) default_value = list[1].value;
			var input = { type: "L", class: 'col-md-12 col-lg-12 text-center sn-i-center', list: list, default_value: default_value };
			
			var buttons = [];
			var btn_confirm = { type: 'confirm', label: 'Submit', class: 'col-md-6 col-lg-6 text-center', event: 'apprver-selected' };
			var btn_cancel = { type: 'cancel', label: 'Cancel', class: 'col-md-6 col-lg-6 text-center', event: 'cancel' };
			buttons.push(btn_confirm);
			buttons.push(btn_cancel);

			this.modalService.openContent(
				DialogComponent,
				{ 
					dlgType: this.dialogService.dlg_type_prompt,
					dlg_config: {
						msgList: msgList,
						input: input,
						buttons: buttons
					}
				},
				{ backdrop: 'static', keyboard: false }
			).result.then(
				(result) => { 
					var params = { approver_ID: result.response.value }
					this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.action_plan.view_ID, this.uscStoreService.action_action_plan_approval, params).subscribe(
						result => {
							if (this.isActionPlanGoalsRequired() && this.isThisMonthActionPlan) {
								this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_todays_goal);
							} else {
								this.loadActionPlan(); 
							}
						}
					)
				},
				(reason) => { this.preprocessP2WFieldsToCurrency(); }
			);        
		}
	}

	approveActionPlan() {
		var params = {  }
		this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.action_plan.view_ID, this.uscStoreService.action_action_plan_approved, params).subscribe(
			result => { this.loadActionPlan(); }
		)
	}

	rejectApproval() {
		var params = {  }
		this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.action_plan.view_ID, this.uscStoreService.action_action_plan_rejected, params).subscribe(
			result => { 
				if (this.current_view == this.uscStoreService.view_p2w_this_action_plan) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_team_this_action_plans);
				if (this.current_view == this.uscStoreService.view_p2w_next_action_plan) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_team_next_action_plans);
			}
		)
	}

	showCustomPromptDlg(item, msg_config): NgbModalRef {
		const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
		modalRef.componentInstance.parentView = this.current_view;
		modalRef.componentInstance.data = item;
		modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_custom_msg;
		modalRef.componentInstance.msg_config = msg_config;
		return modalRef;
	}

	getSearchParams(executeScriptType: string = null) {
		var params: any = {}
		params.p = this.curPage;
		params.ps = this.pageSize;
		params.ob = this.orderBy;
		if (executeScriptType) params.est = executeScriptType;
		params.obd = this.asc ? "asc" : "desc";
		var filter = [
			{ field: "u_user_ID", op: "=", value: this.current_filter.owner.value.length > 0 ? this.current_filter.owner.value : null },
		];
		params.f = JSON.stringify(filter);
		return params;
	}

	getExecuteScriptType(bSearchData: boolean = true, bTotalCount: boolean = true) {
		if (bSearchData && bTotalCount) return "ST_All";
		if (bSearchData) return "ST_Search";
		if (bTotalCount) return "ST_TotalCount";
	}

	onValueChanged(event) {
		var item = event.item;
		var change = event.change;

		for (var key in change) {
			item[key] = change[key];
		}
		this.action_plan = item;

		this.saveActionPlan();
	}

	getViewField(field) {
		var field = (this.action_plan_fields) ? this.action_plan_fields.find(f => f.key == field) : null;
		if (field) { 
			field.cell_style = { "background-color": "#d3e4ea", "border": "none", "text-align": "center", "height": "47px" };
			if (this.isDraft) {
				field.allow_edit = true;
				field.mode = "edit_only";
				field.show_edit_icon = false;
			}
		}
		return field;
	}
	
	public updateMonthGoalsAndActionPlan() {
		this.action_plan_values.postpaid.monthly_goal = this.action_plan_values.postpaid_basic.monthly_goal + this.action_plan_values.postpaid_everyday.monthly_goal + this.action_plan_values.postpaid_even_better.monthly_goal; 
		this.action_plan_values.other_volume.monthly_goal = this.action_plan_values.hsi.monthly_goal + this.action_plan_values.prepaid.monthly_goal + this.action_plan_values.connected_devices.monthly_goal; 
		this.action_plan_values.upgrades.monthly_goal = this.action_plan_values.upgrades_basic.monthly_goal + this.action_plan_values.upgrades_everyday.monthly_goal + this.action_plan_values.upgrades_even_better.monthly_goal; 

		this.action_plan.cs_p2w_postpaid_basic = this.action_plan_values.postpaid_basic.monthly_goal.toString();
		this.action_plan.cs_p2w_postpaid_everyday = this.action_plan_values.postpaid_everyday.monthly_goal.toString();
		this.action_plan.cs_p2w_postpaid_even_better = this.action_plan_values.postpaid_even_better.monthly_goal.toString();
		this.action_plan.cs_p2w_postpaid = this.action_plan_values.postpaid.monthly_goal.toString();
		this.action_plan.cs_p2w_hsi = this.action_plan_values.hsi.monthly_goal.toString();
		this.action_plan.cs_p2w_prepaid = this.action_plan_values.prepaid.monthly_goal.toString();
		this.action_plan.cs_p2w_connected_devices = this.action_plan_values.connected_devices.monthly_goal.toString();
		this.action_plan.cs_p2w_other = this.action_plan_values.other_volume.monthly_goal.toString();
		this.action_plan.cs_p2w_bir = this.action_plan_values.bir.monthly_goal.toString();
		this.action_plan.cs_p2w_accessories_revenue = this.action_plan_values.accessories_revenue.monthly_goal.toString();
		this.action_plan.cs_p2w_other_revenue = this.action_plan_values.other_revenue.monthly_goal.toString();
		this.action_plan.cs_p2w_upgrades_basic = this.action_plan_values.upgrades_basic.monthly_goal.toString();
		this.action_plan.cs_p2w_upgrades_everyday = this.action_plan_values.upgrades_everyday.monthly_goal.toString();
		this.action_plan.cs_p2w_upgrades_even_better = this.action_plan_values.upgrades_even_better.monthly_goal.toString();
		this.action_plan.cs_p2w_upgrades = this.action_plan_values.upgrades.monthly_goal.toString();
		this.action_plan.cs_p2w_high_acc = this.action_plan_values.high_msrp_accessories.monthly_goal.toString();
		this.action_plan.cs_p2w_device_trade_ins = this.action_plan_values.device_trade_ins.monthly_goal.toString();
	}

	onFocusOut(field, bd) {
		if (field && bd) {
			bd[field] = parseInt(bd[field]);
			this.updateMonthGoalsAndActionPlan();
		}

		this.preprocessP2WFieldsToCurrency();
		this.action_plan.cs_observation_notes = JSON.stringify(this.observation_notes);
		// remove any entries with both empty area of focus and sales plan actions 
		var empty_index = this.focus_actions.findIndex(a => a.area_of_focus == '' && a.sales_plan_actions == '');
		while (empty_index >= 0) {
			this.focus_actions.splice(empty_index, 1);
			empty_index = this.focus_actions.findIndex(a => a.area_of_focus == '' && a.sales_plan_actions == '');
		}
		this.action_plan.cs_focus_actions = JSON.stringify(this.focus_actions);
		this.saveActionPlan();
		// add in an empty entry for editting (after saving)
		if (this.focus_actions.length < 5) this.focus_actions.push({ area_of_focus: "", sales_plan_actions: "" });
	}

	// validate conditions 
	validate(updateFormFields: Array<Field<any>>) {
		if (this.viewConditions && updateFormFields) {
		}
	}
	
	getDateValue(value) {
		if (value && value.length > 0) {
			var date = new Date(value);
			return this.calendarService.getDateText(date, "yyyy-MM-dd hh:mm tt");
		}
		return "";
	}

	getCurrentStatus() {
		if (this.isDraft) return "Draft";
		if (this.isRequested) return "Awaiting for Approval";
		if (this.isApproved) return "Approved";
	}

	getBusinessDriverDesc(field) {
		return this.uscStoreService.getBusinessDriverDesc(field);
	}

	submitNotes(field_key, value) {
		this.is_saving_lefn = true;
		var multinotes_field = this.action_plan_fields.find(f => f.key == field_key);
		var params = { sn_ID: multinotes_field.sn_ID, new_notes: value }
		this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_action_plan, this.action_plan.view_ID, this.uscStoreService.action_multinotes_update, params).subscribe(
			result => { this.loadActionPlan(); this.is_saving_lefn = false; }
		)
	}

	isActionPlanGoalsRequired(): boolean {
		return !this.is_store_action_plan && !this.is_assistant_action_plan;
	}

    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }

	print() {
		window.print();
	}
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-action-plan/usc-action-plan.component.ts